// @ts-nocheck
import React from 'react';
import { useForm } from 'react-hook-form';
import { useAppSelector } from '../../../../hooks';
import FormStatic from '../../../common/FormStatic';
import FormInputNumber from '../../../common/FormInputNumber';
import FormToggleGroup from '../../../common/FormToggleGroup';
import { CommaNumber_NoDecimal } from '../../../../util/formatter';
import FormattedDate from '../../../common/FormattedDate';
import KeyProviderLink from '../../../common/links/KeyProviderLink';
import Button from '../../../common/Button';
import { useTranslation } from 'react-i18next';
import { hasPermission } from '../../../auth/authUtils';
import permissionTypes from '../../../../constants/permissionTypes';

export interface ConfirmStepProps {
  request: any;
  saveRequest: (data: any) => void;
  keyProviderRequestInformation?: any[];
}

export default function ConfirmStep({
  request,
  saveRequest,
  keyProviderRequestInformation,
}: ConfirmStepProps) {
  const { t } = useTranslation();
  const currentUser = useAppSelector((state) => state.auth);
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();
  const showAppId = keyProviderRequestInformation?.find(
    (x) => x.type === 'App Id'
  )?.internalSite;
  const showFulfillmentDate = keyProviderRequestInformation?.find(
    (x) => x.type === 'Fullfilment Date'
  )?.internalSite;
  const showKeyProvider = keyProviderRequestInformation?.find(
    (x) => x.type === 'Key Provider'
  )?.internalSite;
  const showLicenseExpires = keyProviderRequestInformation?.find(
    (x) => x.type === 'License Expires'
  )?.internalSite;
  const showPackageId = keyProviderRequestInformation?.find(
    (x) => x.type === 'Package Id'
  )?.internalSite;
  const showProductCode = keyProviderRequestInformation?.find(
    (x) => x.type === 'Product Code'
  )?.internalSite;

  const onSubmit = (data) => {
    saveRequest({
      companyId: request?.company?.id,
      keyWorkflowId: request?.keyWorkflow?.id,
      gameSKUId: request?.sku?.skuId,
      requesterTagId: request?.requesterTag?.id,
      requesterTag: request?.requesterTag?.freeText,
      numberOfKeys: data.numberOfKeys ?? 1,
      keyDeliveryMethod: data.keyDeliveryMethod ?? 0,
    });
  };
  return (
    <>
      {request?.keyWorkflow?.maxKeys !== 1 && (
        <h2 className="mb-4">{t('How many keys?')}</h2>
      )}
      <div className="space-bottom form-horizontal">
        {request?.company?.companyName && (
          <FormStatic label={t('Company')}>
            {request?.company?.companyName}
          </FormStatic>
        )}
        <FormStatic label={t('Request type')}>
          {request?.keyWorkflow?.name}
        </FormStatic>
        <FormStatic label={t('Game')}>{request?.game?.name}</FormStatic>
        <FormStatic label={t('SKU')}>{request?.sku?.name}</FormStatic>
        {showKeyProvider && (
          <FormStatic label={t('Key provider')}>
            <KeyProviderLink id={request?.sku?.keyProviderId} />
          </FormStatic>
        )}
        {showAppId && (
          <FormStatic label={t('App Id')}>{request?.game?.appId}</FormStatic>
        )}
        {showLicenseExpires && (
          <FormStatic label={t('License expires')}>
            {request?.game?.licenseExpires && (
              <FormattedDate value={request?.game?.licenseExpires} variant="noHtml" />
            )}
          </FormStatic>
        )}
        {showPackageId && (
          <FormStatic label={t('Package Id')}>
            {request?.sku?.packageId}
          </FormStatic>
        )}
        {showProductCode && (
          <FormStatic label={t('Product code')}>
            {request?.sku?.steamRef}
          </FormStatic>
        )}
        {showFulfillmentDate && (
          <FormStatic label={t('Fulfillment date')}>
            {request?.sku?.fulfillmentDate && (
              <FormattedDate value={request?.sku?.fulfillmentDate} variant="noHtml" />
            )}
          </FormStatic>
        )}
        {request?.requesterTag && (
          <FormStatic label={t('Tag')}>
            {request.requesterTag.tag ?? request.requesterTag.freeText}
          </FormStatic>
        )}
        {request?.keyWorkflow?.showKeyPoolLevelDuringRequest && (
          <FormStatic label={t('Available keys')}>
            {CommaNumber_NoDecimal(request.keyPoolLevel)}
          </FormStatic>
        )}
        {hasPermission(currentUser, permissionTypes.REQUEST_TO_KEY_POOL) &&
          request?.keyWorkflow?.enableKeyPools && (
            <FormToggleGroup
              control={control}
              name="keyDeliveryMethod"
              label={t('Delivery method')}
              defaultValue={0}
              options={[
                { id: 0, label: t('Download') },
                { id: 1, label: t('Keypool') },
              ]}
            ></FormToggleGroup>
          )}
        {request?.keyWorkflow?.maxKeys === 1 ? (
          <FormStatic label={t('Number of keys')}>1</FormStatic>
        ) : (
          <FormInputNumber
            testId="request-number-of-keys-input"
            register={register}
            required
            name="numberOfKeys"
            label={t('Number of keys')}
            error={errors.numberOfKeys}
            errorMessage={t('Required')}
            autoFocus={true}
          ></FormInputNumber>
        )}
        <Button
          testId="request-add-to-basket-button"
          className="btn btn-primary w-100"
          onClick={handleSubmit(onSubmit)}
          text={t('Add to basket')}
        />
      </div>
    </>
  );
}
